export default "__VITE_ASSET__38P1bYxe__"